import { api } from "./api";

export const videoDuration = (file) => new Promise((resolve) => {
  const v = document.createElement("video");
  v.preload = "metadata";
  const url = URL.createObjectURL(file);
  const done = (d) => { URL.revokeObjectURL(url); resolve(d); };
  v.onloadedmetadata = () => done(Number.isFinite(v.duration) ? v.duration : 0);
  v.onerror = () => done(0);
  v.src = url;
});

export async function uploadVideo(file, { projectId, guideId, duration, onProgress }) {
  const { data } = await api.post("/staff/videos/init", {
    project_id: projectId, guide_id: guideId, size: file.size, duration, content_type: file.type || "video/mp4",
  });
  const size = data.chunk_size;
  for (let i = 0, offset = 0; offset < file.size; i += 1, offset += size) {
    const blob = file.slice(offset, offset + size);
    await api.put(`/staff/videos/${data.upload_id}/chunk`, blob, { params: { index: i }, headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.min(100, Math.round(((offset + blob.size) / file.size) * 100)));
  }
  return (await api.post(`/staff/videos/${data.upload_id}/complete`)).data;
}
